import React from 'react';

import { useQuery } from '@apollo/client';
import { GET_USER_EVENTS_QUERY } from 'Queries/Queries';
import { ReactComponent as SVGKalenderAva } from 'assets/pics/kalendar_avacon.svg';
import { ReactComponent as SVGKalender } from 'assets/pics/kalender.svg';

import { ActionButton } from 'components/ActionButton/ActionButton';
import { LoadingIndicator } from 'components/LoadingIndicator/LoadingIndicator';
import { OuterBox } from 'components/OuterBox/OuterBox';
import { Separator } from 'components/Separator/Separator';

import { FORM_CONSTANTS, TENANT_ID } from 'global/constants';

import { getEventsOverviewPath } from 'utils/UrlUtil';
import { getTenantId } from 'utils/tenantUtil';

import { EventListGroup } from './EventListGroup';

import './EventsCardLong.sass';

const getEventsCardText = (tenantId) => {
  switch (tenantId) {
    case TENANT_ID.EDI: {
      return {
        title: 'Ihre Veranstaltungen',
        text: 'Alle Veranstaltungen',
      };
    }
    case TENANT_ID.SHNG: {
      return {
        title: 'Ihre Veranstaltungen',
        text: 'Alle Veranstaltungen',
      };
    }
    case TENANT_ID.AVA: {
      return {
        title: 'Veranstaltungskalender',
        text: 'Alle Veranstaltungen',
      };
    }
    case TENANT_ID.BAG: {
      return {
        title: 'Veranstaltungskalender',
        text: 'Alle Veranstaltungen',
      };
    }
    case TENANT_ID.LVN: {
      return {
        title: 'Veranstaltungskalender',
        text: 'Alle Veranstaltungen',
      };
    }
    case TENANT_ID.MTN: {
      return {
        title: 'Veranstaltungskalender',
        text: 'Alle Veranstaltungen',
      };
    }
    default: {
      return {
        title: 'Veranstaltungskalender',
        text: 'Alle Veranstaltungen',
      };
    }
  }
};

export const EventsCardLong = () => {
  const tenantId = getTenantId();
  const eventsCardText = getEventsCardText(getTenantId());

  const { loading, data } = useQuery(GET_USER_EVENTS_QUERY, {
    fetchPolicy: 'network-only',
  });

  const events = data?.myRegisteredEvents;

  const renderContent = () => {
    if (events?.length) {
      return <EventListGroup events={events} />;
    }
    return tenantId === TENANT_ID.AVA ? (
      <div>Sie haben sich bisher für keine Veranstaltung registriert!</div>
    ) : (
      <div>Sie haben sich bisher für kein Event registriert</div>
    );
  };

  const separatorColor =
    tenantId === TENANT_ID.SHNG || tenantId === TENANT_ID.AVA ? 'homepage' : 'secondary';

  return (
    <OuterBox className="events-card__outer-box outer-box--p-spacing">
      <div className="events-card__teaser-container">
        <div className="events-card__teaser-title">{eventsCardText.title}</div>
        <div>
          {tenantId === TENANT_ID.AVA ? (
            <SVGKalenderAva
              alt="Calendar icon"
              className="events-card__kalendar"
              width={FORM_CONSTANTS.IMAGE_SIZE}
              height={FORM_CONSTANTS.IMAGE_SIZE}
            />
          ) : (
            <SVGKalender
              alt="Calendar icon"
              className="events-card__kalendar"
              width={FORM_CONSTANTS.IMAGE_SIZE}
              height={FORM_CONSTANTS.IMAGE_SIZE}
            />
          )}
        </div>
      </div>
      <Separator color={separatorColor} />

      {loading ? (
        <LoadingIndicator className="events-card__loading-indicator" />
      ) : (
        <div className="events-card__content-container">{renderContent()}</div>
      )}

      <ActionButton link={getEventsOverviewPath()} title={eventsCardText.text} inverted />
    </OuterBox>
  );
};
